import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './hooks/useAuth'
import Login from './pages/Login'
import Register from './pages/Register'
import Reserve from './pages/Reserve'
import MyPage from './pages/MyPage'
import AdminDashboard from './pages/AdminDashboard'
import AdminPrices from './pages/AdminPrices'
import AdminUsers from './pages/AdminUsers'
import Cancel from './pages/Cancel'
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'

function PrivateRoute({ children, adminOnly = false }: { children: React.ReactElement, adminOnly?: boolean }) {
  const { isLoggedIn, isAdmin, loading } = useAuth()

  if (loading) return <div style={{ textAlign: 'center', padding: '40px' }}>読み込み中...</div>
  if (!isLoggedIn) return <Navigate to="/login" />
  if (adminOnly && !isAdmin) return <Navigate to="/" />

  return children
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Reserve />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/cancel/:token" element={<Cancel />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route
          path="/mypage"
          element={
            <PrivateRoute>
              <MyPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <PrivateRoute adminOnly>
              <AdminDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/prices"
          element={
            <PrivateRoute adminOnly>
              <AdminPrices />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/users"
          element={
            <PrivateRoute adminOnly>
              <AdminUsers />
            </PrivateRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  )
}
